import { ArrowForward } from '@mui/icons-material';
import { Button, Link, Stack, Typography } from '@mui/material';
import { OutlinedTextField } from '@my2n/react-hook-form-inputs';
import { FormProvider } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { FilledInfoBar } from '../../../../components/_DesignSystemWrappers/InfoBar/FilledInfoBar';
import { RouterLink } from '../../../ResetPasswordPage/components/Link/PrimaryLink';
import messages from './messages';
import { useMFARecoveryForm } from './useMFARecoveryForm';
import { FormFieldNames } from './validationSchema';

export interface IMFARecoveryProps {
  onBack: () => void;
  onSuccess?: () => void;
}

export function MFARecoveryForm(props: IMFARecoveryProps) {
  const { formatMessage, formData, formSubmit, isOryApiFetching } = useMFARecoveryForm({
    onSuccess: props.onSuccess,
  });

  return (
    <Stack spacing={3}>
      <FilledInfoBar>
        <Typography variant="body2" component="div">
          <FormattedMessage
            {...messages.ImsTwoFactorAuthenticationCantAccessAlertTextV2}
            values={{
              b: (chunks) => <b>{chunks}</b>,
              link: (chunks) => (
                <Link
                  href="https://www.2n.com/en-GB/support/#verticaltabscontainer-do-you-need-support-or-help"
                  target="_blank"
                >
                  {chunks}
                </Link>
              ),
            }}
          />
        </Typography>
      </FilledInfoBar>
      <FormProvider {...formData}>
        <form onSubmit={formData.handleSubmit(formSubmit)}>
          <Stack spacing={1}>
            <OutlinedTextField
              id="totp-recovery"
              label={formatMessage(messages.ImsTwoFactorAuthenticationCantAccessRecoveryCode)}
              name={FormFieldNames.TotpRecoveryCode}
              required
              fullWidth
              helperText={formatMessage(messages.ImsTwoFactorAuthenticationCantAccessRecoveryCodeHelperText)}
            />
            <Button
              color="primary"
              disabled={!formData.formState.isValid || isOryApiFetching}
              fullWidth
              id="TOTP-submit"
              startIcon={<ArrowForward />}
              size="large"
              type="submit"
              variant="contained"
            >
              <FormattedMessage {...messages.ImsTwoFactorAuthenticationCantAccessRecoveryCodeSubmit} />
            </Button>
            <RouterLink onClick={() => props.onBack()} styles={{ pt: 1 }} to="">
              <FormattedMessage {...messages.ImsTwoFactorAuthenticationCantAccessBack} />
            </RouterLink>
          </Stack>
        </form>
      </FormProvider>
    </Stack>
  );
}
